<woo-modal-layout size="medium" (close)="close()">
  
  <h3 header class="title-align-left">{{content().title}}</h3>

  @if(content()) {
    <div class="content-align-left">
      @for(block of content().texts; track $index;) {
        <p [innerHTML]="block"></p>
      }

      @for(warning of content().warnings; track $index;) {
        <div e2e-id="confirm-dialog-warnings">
          <h3 class="text-warning"><span class="icon-warning"></span> {{warning.title}}</h3>
          @for(warnText of warning.texts; track $index;) {
            <p [innerHTML]="warnText"></p>
          }
        </div>
      }
    </div>

      <form #form="ngForm" (ngSubmit)="form.valid ? submit() : setFormDirty(form.control)">
        @if(content().comment) {
          <div class="input__container input-padding">
            @if(content().comment.required) {
              <label for="comment">{{content().comment.label}}<span> *</span></label>
            }
            <textarea id="comment" type="text" name="comment" [(ngModel)]="content().comment.text" [required]="content().comment.required" [placeholder]="content().comment.placeholder ?? ''"></textarea>
            @if(content().comment.required) {
              @if(form.controls.comment?.invalid) {
                <p class="text--small text--danger">Måste fyllas i</p>
              }
            }
          </div>
        }

        @if(content().consent) {          
          <div class="margin-bottom--2x input-padding">
            @if(content().consent.text) {
              <p class="text--strong"><span class="icon-warning text--warning"></span>  {{content().consent.text}}</p>
            }
              <input type="checkbox" class="checkbox" id="consent-box" name="consent" [(ngModel)]="consent" required>
              <label for="consent-box" class="checkbox">{{content().consent.label}}</label>
          </div>
        }
        <inline-group footer gap="small" class="footer">
          <button id="modal-confirm" [attr.e2e-id]="'modal-confirm'" footer class="button primary-1" type="submit" [disabled]="(content().consent && !consent()) || (content().comment && content().comment.required && !content().comment) || form.invalid">{{content().confirmLabel}}</button>
          <button id="modal-cancel" [attr.e2e-id]="'modal-cancel'" class="link primary-1" (click)="abort()" type="button">{{content().cancelLabel}}</button>
        </inline-group>
      </form>
    }
</woo-modal-layout>